module.exports = __webpack_public_path__ + "img/entertainment-1.e5b9b681.jpg";